export const queryReferralsByJobIdEmailPhone = `query QueryReferralsByJobIdEmailPhone(
    $jobId: ID!
    $emailAddress: String
    $phoneNumber: String
  ) {
    queryReferralsByJobIdEmailPhone(
      jobId: $jobId
      emailAddress: $emailAddress
      phoneNumber: $phoneNumber
    ) {
        items {
            id
        }
        nextToken
    }
  }
  `;
